export default __webpack_public_path__ + "static/media/cha5.0f1d8230.png";